import { atom } from 'recoil';
// TODO: WARNING: with the real offers api, we might not get the *full* objects in the array -> check!
export const offersAtom = atom({
    key: 'offers',
    default: null,
});
// IMPORTANT: This assumes that we only use the legacy offer blob!
export const offerDetailsAtom = atom({
    key: 'offerDetails',
    default: {},
});
// fetch -> /claims -> claimsAtom<Claim[]> -> teile
// fetch -> /claims/:id -> claimDetailsAtom<Claim> -> full claim
